<template>
<!-- <SocketProvider> -->
  <div id="app">
    <el-container v-if="isLoadingFunc">
      <navigation v-if="showNavigation"/>
      <el-main>
        <header-strip></header-strip>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
<!-- </SocketProvider> -->
</template>
<script>
import HeaderStrip from '../components/common/HeaderStrip.vue'
import NavigationVue from '../components/common/Navigation.vue';
// import SocketProvider from '../api/SocketProvider';
export default {
  mounted() {
    //  to void ui glitchs or previous layout etc.
    let self = this
    let menuItem = self.$router.options.routes
    let result = _.some(menuItem, (e) => {
      return self.$route.path.includes(e.path)
    })
    // let menuList = JSON.parse(localStorage.getItem('menu'))
    // let mlist = _.some(menuList, (m) => {
    //   return self.$route.path.includes(m.path)
    // })
    // if (mlist && result) {
    if (result) {
      self.isLoading = true;
    } else {
      self.isLoading = false
      self.$store.dispatch("auth/LOGOUT").then(() => {
        localStorage.setItem('userdetails',null)
        self.$router.push("/login");
      });

    }
  },
  components:{
    'header-strip':HeaderStrip,
    'navigation': NavigationVue,
    // SocketProvider
  },
  data () {
    return {
      isLoading:false,
      open: false
    }
  },
  computed:{
    isLoadingFunc:function(){
      let token = this.$store.getters['auth/getToken'];
      if(token) return this.isLoading;
    },
    showNavigation () {
      return this.$store.getters['auth/getNavigation'];
    }
  },
  watch: {
    $route(to, from) {
      this.$store.commit('auth/setNavigation', true)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/layouts/DesktopLayout.vue